import React from "react";
import {
  BrowserRouter,
  Route,
  Routes as BrowserRoutes,
  Navigate,
} from "react-router-dom";
import AuthModule from "../components/Auth";
import Login from "../components/Auth/Login";
import Index from "../pages/Layout";
import Dashboard from "../components/Dashboard";
import ForgotPassword from "../components/Auth/ForgotPassword";
import DashboardListing from "../components/Dashboard/DashboardListing";
import Admin from "../components/Admin";
import Roles from "../components/Admin/Roles";
import User from "../components/User";
import UsersList from "../components/User/UsersList";
import ChangePassword from "../components/Auth/ChangePassword";
import AddRole from "../components/Admin/Roles/AddRole";
import AdminUser from "../components/Admin/AdminUser";
import Store from "../components/Admin/Store";
import Products from "../components/Products";
import Product from "../components/Products/Product";
import Category from "../components/Admin/Category";
import OrderList from "../components/Admin/OrderList";
import Faq from "../components/User/Faq";
import Banner from "../components/User/Banner";
import UserDetailLayout from "../components/User/UserDetailLayout";
import UserDetailView from "../components/User/UserDetailView";
import Staff from "../components/Staff";
import StaffList from "../components/Staff/SatffList";
import ActivityLog from "../components/Admin/ActivityLog";
import ContactUs from "../components/User/ContactUs";
import ProductDetailLayout from "../components/Products/Product/ProductDetailLayout";
import ProductDetailView from "../components/Products/Product/ProductDetailView";
import Appearance from "../components/Admin/Settings/Appearance";
import useTheme from "../components/Admin/Settings/Appearance/useTheme";
import TransactionLists from "../components/User/TransactionLists";
import CMS from "../components/CMS";
import ContentList from "../components/CMS/ContentList";
import TransactionType from "../components/User/TransactionType";
import useDrawerTheme from "../components/Admin/Settings/Appearance/useDrawerTheme";
import HomePage from "../components/CMS/HomePage";
import VideoContent from "../components/CMS/VideoContent";
import CustomOffers from "../components/User/CustomOffers";
import BestSeller from "../components/Reports/BestSeller";
import MostSpentCustomer from "../components/Reports/MostSpentCustomer";
import EarningAndRedemption from "../components/Reports/EarningAndRedemption";
import RepeatCustomer from "../components/Reports/RepeatCustomer";
import RepeatOrder from "../components/Reports/RepeatOrder";
import Report from "../components/Reports";
import GiftCards from "../components/User/GiftCards";
import Feedback from "../components/User/Feedback";
import MyCards from "../components/Reports/MyCards";
import WalletTransaction from "../components/Reports/WalletTransaction";
import VideoBanner from "../components/User/VideoBanner";
import CustomNotification from "../components/CMS/CustomNotification";
import NotificationDeliveryReport from "../components/CMS/CustomNotification/NotificationDeliveryReport";
import DeliveryAreas from "../components/Admin/DeliveryAreas";
import Survey from "../components/User/Survey";
import UserFeedback from "../components/Reports/UserFeedback";
import CardOffer from "../components/Reports/CardOffer";
import QubriuxOffer from "../components/Reports/QubriuxOffer";
import AiOrderList from "../components/Admin/AiOrderList";
import SplashScrreen from "../components/User/SplashScrreen";
import Placeholder from "../components/User/Placeholder";
import SeasonalTheme from "../components/User/SeasonalTheme";
import PopularSearch from "../components/User/PopularSearch";
import OfficeDelivery from "../components/User/OfficeDelivery";
import SpinWheelRewards from "../components/Reports/SpinWheelRewards";
import SubscriptionReport from "../components/Reports/SubscriptionReport";
import SubscriptionOrders from "../components/Reports/SubscriptionOrders";
import AiSettings from "../components/CMS/AiSettings";
import FavouriteCategory from "../components/User/FavouriteCategory";
import YearlyRecap from "../components/CMS/YearlyRecap";
import SubscriptionAccess from "../components/CMS/SubscriptionAccess";
import SeasonalStoreTimeing from "../components/Admin/SeasonalStoreTimeing";
import SubscriptionPlans from "../components/User/SubscriptionPlans";
import PlanGroupList from "../components/User/SubscriptionPlans/PlanGroupList";
import CustomerSubscriptions from "../components/User/CustomerSubscriptions";

const Routes = () => {
  useTheme("light");
  useDrawerTheme("expanded");
  return (
    <BrowserRouter>
      <BrowserRoutes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<AuthModule />}>
          <Route path="" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="" element={<DashboardListing />} />
        </Route>
        <Route path="/admin" element={<Admin />}>
          <Route path="roles" element={<Roles />} />
          <Route path="roles/role-update" element={<AddRole />} />
          <Route path="admin-user" element={<AdminUser />} />
          <Route path="store" element={<Store />} />
          <Route path="category" element={<Category />} />
          <Route path="orders" element={<OrderList />} />
          <Route path="ai-orders" element={<AiOrderList />} />
          <Route path="activity" element={<ActivityLog />} />
          <Route path="delivery-areas" element={<DeliveryAreas />} />
          <Route path="settings" element={<Appearance />} />
          <Route path="seasonal-store-timing" element={<SeasonalStoreTimeing />} />
        </Route>
        <Route path="/admin/store/product-list" element={<Products />}>
          <Route path="" element={<Product />} />
        </Route>
        <Route path="/user" element={<User />}>
          <Route path="users" element={<UsersList />} />
          <Route path="banner" element={<Banner />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="faq" element={<Faq />} />
          <Route path="survey" element={<Survey />} />
          <Route path="transaction-type" element={<TransactionType />} />
          <Route path="transactions" element={<TransactionLists />} />
          <Route path="offers" element={<CustomOffers />} />
          <Route path="gift-cards" element={<GiftCards />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="video-content" element={<VideoBanner />} />
          <Route path="dynamic-splash-screens" element={<SplashScrreen />} />
          <Route path="placeholder" element={<Placeholder />} />
          <Route path="seasonal-theme" element={<SeasonalTheme />} /> 
          <Route path="popular-search" element={<PopularSearch />} /> 
          <Route path="favourite-category" element={<FavouriteCategory />} /> 
          <Route path="office-delivery" element={<OfficeDelivery />} />
          <Route path="subscription-plans" element={<SubscriptionPlans />} />
          {/* The sizes folded into one row on the listing above, as rows again. */}
          <Route
            path="subscription-plans/group/:productID"
            element={<PlanGroupList />}
          />
          <Route
            path="customer-subscriptions"
            element={<CustomerSubscriptions />}
          />
        </Route>
        <Route path="user-profile" element={<UserDetailLayout />}>
          <Route path=":userID" element={<UserDetailView />} />
        </Route>
        <Route path="product-detail" element={<ProductDetailLayout />}>
          <Route path=":productID" element={<ProductDetailView />} />
        </Route>
        <Route path="/staff" element={<Staff />}>
          <Route path="list" element={<StaffList />} />
        </Route>
        <Route path="/cms" element={<CMS />}>
          <Route path="policies-terms" element={<ContentList />} />
          <Route path="home-page" element={<HomePage />} />
          <Route path="video" element={<VideoContent />} />
          <Route path="custom-notifications" element={<CustomNotification />} />
          <Route
            path="custom-notifications/:notificationID/report"
            element={<NotificationDeliveryReport />}
          />
          <Route path="ai-settings" element={<AiSettings/>} />
          <Route path="yearly-recap" element={<YearlyRecap/>} />
          <Route path="subscription-access" element={<SubscriptionAccess/>} />
        </Route>
        <Route path="/report" element={<Report />}>
          <Route path="best-seller" element={<BestSeller />} />
          <Route path="most-spent-customer" element={<MostSpentCustomer />} />
          <Route path="earning-redemption" element={<EarningAndRedemption />} />
          <Route path="repeat-customer" element={<RepeatCustomer />} />
          <Route path="repeat-order" element={<RepeatOrder />} />
          <Route path="gift-cards-purchase" element={<MyCards />} />
          <Route path="wallet-transaction" element={<WalletTransaction />} />
          <Route path="feedback" element={<UserFeedback />} />
          <Route path="card-offer" element={<CardOffer />} />
           <Route path="qubriux-offer" element={<QubriuxOffer />} />
           <Route path="spin-wheel-rewards" element={<SpinWheelRewards/>} />
           <Route path="subscription" element={<SubscriptionReport />} />
           <Route path="subscription-orders" element={<SubscriptionOrders />} />
        </Route>

        <Route path={"/*"} element={<Navigate to={"/"} />} />
      </BrowserRoutes>
    </BrowserRouter>
  );
};

export default Routes;
